import { useQuery } from 'convex/react';
import { api } from '../../convex/_generated/api';
import type { Id } from '../../convex/_generated/dataModel';
import { useConvexMutation } from './use-convex-mutation';

export type SessionType =
  | 'group'
  | 'private'
  | 'clinic'
  | 'match_play'
  | 'cardio_tennis'
  | 'squads';

export interface SessionRate {
  id: Id<'sessionTypeRates'>;
  sessionType: SessionType;
  termRateCents: number;
  updatedAt: number;
}

export function useSessionRates() {
  const data = useQuery(api.director.sessionRates.list);
  return { data: data ?? null, isLoading: data === undefined };
}

export function useUpsertSessionRate() {
  const { mutateAsync, isPending } = useConvexMutation(
    api.director.sessionRates.upsert
  );
  return {
    isPending,
    mutateAsync: (args: { sessionType: SessionType; termRateCents: number }) =>
      mutateAsync(args),
  };
}

export function useRemoveSessionRate() {
  const { mutateAsync, isPending } = useConvexMutation(
    api.director.sessionRates.remove
  );
  return {
    isPending,
    mutateAsync: (sessionType: SessionType) => mutateAsync({ sessionType }),
  };
}
